var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    stroke: "#D8D8D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.999 32c0 14.359-11.64 26-26 26C17.64 58 6 46.358 6 32c0-14.36 11.641-26 26-26 14.36 0 26 11.64 26 26z",
    fill: "#46A2CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.68 26.947c.927 0 1.68.753 1.68 1.68V40.74a1.68 1.68 0 11-3.36 0V28.627c0-.927.752-1.68 1.68-1.68zM31 22.16a1.68 1.68 0 113.36.001A1.68 1.68 0 0131 22.16z",
    fill: "#fff"
  })));
}
export default SvgInformationIcon;